import { Injectable } from "@angular/core";
import { EdlPubSubLogApi } from "src/app/api/edl-pub-sub-log/edl-pub-sub-log.api";
import { PagedModel } from "src/app/model/common/paged.model";
import { EdlPubSubLogFilters } from "src/app/model/edl-pub-sub-log/edl-pub-sub-log-filters.model";

@Injectable()
export class EdlPubSubLogService {

    constructor(
        private edlPubSubLogApi: EdlPubSubLogApi
    ) { }

    getLogs = (paging: PagedModel, filters: EdlPubSubLogFilters) => this.edlPubSubLogApi.getLogs(paging, filters);

    undoAction = (logId: string) => this.edlPubSubLogApi.undoAction(logId);
}